export default {
  general: {
    back: 'Назад в аккаунт',
    backFarm: 'Назад в Ферму',
  },
  user: {
    settings: 'Настройки аккаунта'
  },
  summary: {
    title: 'Финансы',
    yesterday: 'Доход за вчера',
    total: 'Доход за все время',
    withdrawn: 'Выведенно',
    balance: 'Баланс',
    withdrawNow: 'Вывод',
    income: "Доход",
    todayEstimate: "Расчет за сегодня:",
    finance: "Финансы",
    incomeHistory: "История доходов",
    withdrawalHistory: "История вывода",
    totalIncomeHint1: "Не включает в себя доход за сегодня",
    totalIncomeHint2: "Доход за сегодня будет зачислен на ваш баланс в 00:00 UTC (время Лондона)",
  },
  farms: {
    title: 'Ваши фермы',
    share: 'Ваша доля',
    yesterday: 'Доход за вчера',
    total: 'Доход за все время',
    view: 'Подробнее'
  },
  table: {
    total: 'Итого',
    noData: 'Записи не найденны'
  },
  income: {
    title: 'История дохода',
    amount: 'Сумма',
    date: 'Дата',
    farm: 'Ферма',
  },
  withdrawals: {
    title: 'История вывода',
    amount: 'Сумма',
    date: 'Дата',
    address: 'Адрес',
    status: 'Статус',
    pending: 'Ожидание',
    paid: 'Готово',
    withdrawNow: 'Новый вывод'
  },
  account: {
    title: 'Настройки аккаунта',
    enterName: 'Ваше имя',
    saveChanges: 'Сохранить изменения',
    cancelChanges: 'Отмена',
    changesSaved: 'Изменения сохраненны',
    saving: 'Сохранение...',
    retypeNewPassword: 'Повторите пароль',
    passwordSaved: 'Новый пароль сохранен',
    deleteAccount: 'Хотите удалить аккаунт?',
    contactSupport: 'Связаться с поддержкой',
    questions: 'Есть вопросы по вашим заказам?',
    getHelp: 'Нужна помощь',
    wrongPassword: 'Неверный пароль',
    oldPassword: 'Старый пароль',
    min6chars: 'Минимум 6 символов',
    newPassword: 'Новый пароль',
    loginMethods: 'Способы входа',
    viaPassword: "Пароль",
    viaSocial: 'Через ',
    enterCurrentPassword: 'Текущий пароль',
    change: 'Сменить',
    remove: 'Удалить',
    setPassword: 'Создать',
    removeWarning: 'Если вы удалите пароль, то вы сможете входить только через Google',
    removePassword: 'Удалить пароль',
    removingPassword: 'Удаление пароля...',
    cancel: 'Отмена',
    disable: 'Запретить',
    enable: 'Разрешить',
    twitterTokenAccess: 'Twitter Bot Access Token',
    generateToken: 'Generate Token',
    deleteToken: 'Delete Token',
  },
  farmInfo: {
    'deviceDetails': 'Детали устройства',
    'model': 'Модель',
    'hashrate': 'Хэшрейт',
    'power': 'Мощность',
    'watts': 'Вт',
    'price': 'Стоимость',
    'desc': 'Групповая майнинг-ферма "%miniFarmTitle%" состоит из %devices%. ' +
      'Это одна из самых популярных машин для майнинга.',
    'desc2': 'Вы становитесь партнером компании Xive и совладельцем фермы "%miniFarmTitle%" в соответствии ' +
      'с процентной долей, которую вы приобрели. Цены на оборудование и хостинг остаются такими же, ' +
      'как по себестоимости у Xive.',
    'desc3': 'Xive применяет только %miniFarmServiceFee% управленческую комиссию к полученным прибылям.',
    'deviceDesc': '%count% устройств %model% с хешрейтом %rate% каждое',
    'groupMiningDetails': 'Сведения о групповой майнинговой ферме',
    'totalHashrate': 'Общий хэшрейт',
    'totalValue': 'Общая стоимость',
    'devices': 'Устройства',
    'hostingDetails': 'Сведения о хостинге',
    'electricityFee': 'Плата',
    'kwh': 'кВт/ч',
    'securityDeposit': 'Депозит',
    'days': 'дней',
    'profitSharing': 'Коммисия доли',
  },
  farmSummary: {
    title: 'Финансы',
    yesterday: 'Доход за вчера',
    total: 'Доход за все время',
    deposit: 'Депозит',
    stake: 'Доля в ферме'
  },
  farmIncome: {
    title: 'История дохода',
    amount: 'Сумма',
    date: 'Дата'
  },
  farmOrders: {
    title: 'История покупок',
    date: 'Дата',
    stake: 'Доля в ферме',
    amount: 'Стоимость',
    deposit: 'Депозит'
  },
  withdrawal: {
    sendBtc: 'Вывод BTC',
    loadingBalance: 'Загрузка баланса...',
    network: 'Сеть:',
    selectNetwork: 'Выберите сеть',
    bitcoinNetwork: 'Bitcoin сеть',
    binanceNetwork: 'BNB Smart Chain (BEP20)',
    address: 'Адрес:',
    invalidAddress: 'Неверный адрес',
    walletOk: 'Адрес OK',
    mainnetRequired: 'требуется MainNet кошелек',
    mustBeBitcoinNetwork: 'Адрес кошелька должен быть действительным <b>Bitcoin сеть</b> адресом',
    mustBeBinanceNetwork: 'Адрес кошелька должен быть действительным <b>Binance BEP 20 (BSC)</b> адресом',
    transactionsIrreversible: 'Все BTC транзакции необратимые: если вы введете неверный BTC адрес ' +
      'ваши средства <b>будут потерены</b>!',
    sendFrom: 'Отправить с:',
    selectWallet: 'Выберите кошелек',
    amount: 'Сумма:',
    max: 'Макс.',
    available: 'Доступно:',
    minAmount: 'Минимальная сумма:',
    notEnoughBalance: 'Ваш баланс недостаточен для вывода',
    receiveAmount: 'Сумма к получению:',
    calculating: 'подсчет...',
    networkFee: 'Коммисия сети',
    continue: 'Продолжить',
    checking: 'Проверка...',
    confirmWithdrawal: 'Подтверждение вывода',
    verifyWithdrawal: 'Пожалуйста подтвердите вывод',
    sixDigitsSent: 'Шестизначный код был выслан на ваш email адрес, проверьте вашу почту',
    confirm: 'Подтвердить',
    withdrawalRequested: 'Вывод подтвержден',
    willBeWithdrawn: 'Сумма, которая вы запросили будет выслана в течении нескольких часов',
    close: 'Закрыть',
    wrongCode: 'Вы ввели неверный код, пожалуйста, проверьте код',
    enterCryptoAddress: 'Введите крито кошелек',
    enterAmount: 'Введите сумму',
  }
}